export class UpdateVaultDocumentFolderPathRequest{
    public idList!:Array<number>;
    public folderStructureId!:number;
    public folderStructurePath!:string;
}
